import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { searchAction } from '../../../actions/searchActions';
import { sendToCommunityAInvite } from '../../../actions/userActions';
import { CloseIcon } from '../../../assets/icons';
import { Translate } from '../../../language';
import Button from '../../../utils/components/Button/Button';
import ImageNameDescription from '../../../utils/components/ImageNameDescription/ImageNameDescription';
import InputSearch from '../../../utils/components/InputSearch/InputSearch';

import style from "./ZoneRoomAdmin.module.css";
const AdminInviteZone = ({ zone }) => {
    const [usersToInvite, setUsersToInvite] = useState([])
    const { isLoadingSearchList, searchList } = useSelector(state => state.users)
    const dispatch = useDispatch()

    /*   setUsersToInvite(users => {
          return [...users, user]
      }) */
    return (
        <div className={style.content_right_container}>
            <InputSearch
                placeholder={Translate('searchPalcheholder', 'es')}
                classNameContent=""
                searchData={(value) => dispatch(searchAction(value, "userAndFranchises"))}
                isLoading={isLoadingSearchList}
                renderData={searchList && searchList.userAndFranchises && (
                    <>
                        {
                            searchList.userAndFranchises[0].users.map(user => {
                                let data = user;
                                if (user.warehouseID) {


                                    data._id = user.warehouseID
                                    data.lastname = null

                                }
                                if (user.representativeID) {
                                    if (user.representativeID.state ===2) {

                                        data = user.representativeID
                                    }
                                }
                                if (usersToInvite.find(userToInvite => userToInvite._id === data._id)) {
                                    return <></>
                                }
                                return (
                                    <ImageNameDescription
                                        key={user._id}
                                        options={[]}
                                        onClick={(e) => {
                                            e.preventDefault(); e.stopPropagation();
                                            setUsersToInvite(users => {
                                                return [...users, data]
                                            })

                                        }}
                                        description={null}
                                        srcImage={user.picture && user.picture.url ? user.picture.url.small : user.picture}
                                        firstName={user.name}
                                        secondName={user.lastname}
                                    />
                                )
                            }

                            )
                        }
                        {
                            searchList.userAndFranchises[0].franchises.map(franchise => {
                                if (usersToInvite.find(userToInvite => userToInvite._id === franchise._id)) {
                                    return <></>
                                }
                                return <ImageNameDescription
                                    key={franchise._id}
                                    options={[]}
                                    onClick={(e) => {
                                        e.preventDefault(); e.stopPropagation();
                                        setUsersToInvite(users => {
                                            return [...users, franchise]
                                        })
                                    }}
                                    description={null}
                                    srcImage={franchise.picture && franchise.picture.url ? franchise.picture.url.small : franchise.picture}
                                    firstName={franchise.socialReason}

                                />
                            }

                            )
                        }
                    </>
                )}
            />
            <div style={{
                height: "65vh"
            }} className='scroll-menu'>
                {
                    usersToInvite.map(user => (
                        <div className={style.user_to_invite}>
                            <ImageNameDescription
                                type={style.user_to_invite_ind}
                                key={user._id}
                                onClick={(e) => {

                                }}
                                srcImage={user.picture && user.picture.url ? user.picture.url.small : user.picture}
                                firstName={user.name ? user.name: user.socialReason}
                                secondName={user.lastname}
                                description={null}
                            />
                            <div>
                                <CloseIcon
                                    onClick={(e) => {
                                        e.preventDefault(); e.stopPropagation();
                                        setUsersToInvite(users => {
                                            //return [...users, user]
                                            var prevStateDelete = users.filter(u => u._id !== user._id)

                                            return prevStateDelete
                                        })
                                    }}
                                    height={20} />
                            </div>
                        </div>
                    ))
                }
            </div>
            <div>
                <Button
                    onClick={() => {
                        usersToInvite.forEach(user => {
                            dispatch(sendToCommunityAInvite(zone._id, user._id, () => {
                                setUsersToInvite([])
                            }))
                        });
                    }}
                    text='Invitar'
                />
            </div>
        </div>
    )
}

export default AdminInviteZone